import moment from 'moment-timezone'
import airportTimezone from '../dates/airportTimezone.js'

const decodeItineraryId = itirenaryId => {
  const [depart, arrive, dateTime, code, cabin] = itirenaryId.split('-')
  return {
    depart,
    arrive,
    departDate: moment(dateTime, 'YYMMDDHHmm').tz(airportTimezone(depart), true),
    airline: {
      code,
    },
    cabin,
  }
}

export default itinerary => itinerary.split(',').map(decodeItineraryId)


